import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import Topbar from "@/components/Topbar";

export default function Layout() {
  const { pathname } = useLocation();
  return (
    // h-screen + overflow-hidden (بدل min-h-screen بلا overflow) — هذا هو
    // الفرق الجوهري: min-h-screen يسمح للصفحة كلها بالنمو أطول من الشاشة،
    // فلا يُفعَّل أي overflow-y-auto داخلي أبدًا (المتصفح يمرّر الصفحة كلها
    // بدل المحتوى الداخلي، وأي عنصر بلا قيد ارتفاع فعلي لا "يفيض" ليطلب
    // Scroll إطلاقًا). بتثبيت ارتفاع الحاوية الخارجية على ارتفاع الشاشة
    // بالضبط ومنع تجاوزها، يصبح <main> أدناه هو المسؤول الوحيد عن التمرير
    // لمحتواه — بالضبط السلوك المطلوب (Sidebar/Header ثابتان، والمحتوى فقط
    // يتمرّر).
    <div className="h-screen flex overflow-hidden" style={{ background: "#F8FAF7" }} data-testid="app-layout">
      <Sidebar />
      {/* min-h-0 ضروري هنا: بدونها، عناصر Flexbox لا تنكمش تحت الحجم
          الطبيعي لمحتواها بشكل افتراضي (min-height: auto)، فيبقى overflow
          على أي عنصر ابن بلا أثر مهما كان طويلاً — هذا بالضبط سبب عدم عمل
          overflow-y-auto على <main> سابقًا رغم وجوده. */}
      <div className="flex-1 min-w-0 min-h-0 flex flex-col">
        <Topbar />
        <main className="flex-1 min-h-0 overflow-x-auto overflow-y-auto">
          <div className="mx-auto max-w-[1440px] px-8 py-8 animate-enter" key={pathname}>
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
